import { createImageSliderSlide } from './__mocks__/imageSliderSlide'
import { StoryblokImageSliderSlide } from './StoryblokImageSliderSlide'

export { createImageSliderSlide } from './__mocks__/imageSliderSlide'

// Re-export for backward compatibility
export const dummyStoryblokImageSliderSlide = createImageSliderSlide()

export default StoryblokImageSliderSlide
